function handoff({ target, summary }, ctx) {
    const allowed = ctx.agentConfig?.handoff_target_codes || [];
    if (!target || !allowed.includes(target)) {
        return {
            ok: false,
            detail: `handoff target is not allowed: ${target || "(missing)"}`
        };
    }

    const normalizedSummary = typeof summary === "object"
        ? summary
        : { intent: String(summary || ""), fields_set: {}, open_questions: [] };

    ctx.requestHandoff?.({
        targetId: target,
        contextSummary: normalizedSummary
    });

    return {
        ok: true,
        detail: `Transfer accepted. Tell the user you are connecting them to ${target}, then stop speaking.`
    };
}

export const agentTools = [
    {
        key: "agent.handoff",
        schema: {
            type: "function",
            description: "Transfer control to an allowed voice agent target.",
            parameters: {
                type: "object",
                properties: {
                    target: { type: "string" },
                    summary: {
                        type: "object",
                        properties: {
                            intent: { type: "string" },
                            fields_set: { type: "object" },
                            open_questions: {
                                type: "array",
                                items: { type: "string" }
                            }
                        },
                        required: ["intent"]
                    }
                },
                required: ["target", "summary"]
            }
        },
        executor: handoff
    }
];
